import { getMainTableBookingApi } from "../../api/home/mainTableBookingApi";
import {
  GET_MAIN_TABLEBOOKING_SUCCESS,
  GET_MAIN_TABLEBOOKING_FAILURE,
} from "../types";

export const getMainTableBookingSuccess = (homepage) => ({
  type: GET_MAIN_TABLEBOOKING_SUCCESS,
  payload: homepage,
});

export const getMainTableBookingFailure = (error) => ({
  type: GET_MAIN_TABLEBOOKING_FAILURE,
  payload: error,
});

export const getMainTableBooking = (postData) => {
  return (dispatch) => {
    getMainTableBookingApi(postData)
      .then((response) => {
        dispatch(getMainTableBookingSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getMainTableBookingFailure(error.message));
      });
  };
};
